import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { EmpDetails, Header } from "@aptsi-types";
import { IdentityProvisioningService } from "../identity-provisioning/identity-provisioning.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { tryCatch } from "rxjs/internal-compatibility";
import { TerminateDialogComponent } from "../shared/dialogs/terminate-dialog.component";
import { SuccessDialogComponent } from "../shared/dialogs/success-dialog/success-dialog.component";
import { DeleteDialogComponent } from "../shared/dialogs/delete-dialog/delete-dialog.component";

@Component({
  selector: "app-identity-admin-panel",
  templateUrl: "./identity-admin-panel.component.html",
  styleUrls: ["./identity-admin-panel.component.scss"],
})
export class IdentityAdminPanelComponent {
  totalPages = 0;
  totalPagesNormal = 0;
  totalPagesSearch = 0;

  itemsPerPage =7;
  currentPage = 1 ;


  get paginatedData() {
    
      if(!this.issearch){
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredData.slice(start, end);
      }
      else{
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        
        return this.searchedData.slice(start, end);
      }
      
    
  }

  changePage(page: number) {
    this.currentPage = page;
    if (!this.issearch) {
      this.totalPages = this.totalPagesNormal;  // Ensure correct total pages
      this.fetchempDetails();
    } else {
      this.totalPages = this.totalPagesSearch;  // Ensure correct total pages
      this.fetchempDetailsSearch();
    }
  }
  
  filteredData: EmpDetails[] = []; 
  searchedData: EmpDetails[] = []; 

  headers: Header[] = [
    {
      name: "Digital Id",
      property: "guid",
      showInDropdown: false,
      description: "Globally unique identifier for the digital record", // Tooltip content
    },
    {
      name: "Employee Id",
      property: "id",
      showInDropdown: true,
      description: "Unique identifier assigned to the employee",
    },
    {
      name: "Name",
      property: "displayName",
      showInDropdown: true,
      description: "Full name of the employee",
    },
    {
      name: "Email",
      property: "mail",
      showInDropdown: false,
      description: "Email address of the employee",
    },
    {
      name: "Status",
      property: "status",
      showInDropdown: false,
      description: "Current status of the employee or record",
    },
    {
      name: "Organization",
      property: "organization",
      showInDropdown: true,
      description: "Organization to which the employee belongs",
    },
    {
      name: "Organizational Unit",
      property: "organizational_unit",
      showInDropdown: true,
      description: "Specific unit or department within the organization",
    },
    {
      name: "Organization Id",
      property: "organizationId",
      showInDropdown: true,
      description: "Unique identifier for the organization",
    },
    {
      name: "Source System",
      property: "sourceSystem",
      showInDropdown: true,
    },
    {
      name: "Start Date",
      property: "startDate",
      showInDropdown: false,
      description: "Date when the employee started working",
    },
  ];
  

  searchText: string = null;
  filterByHeader: string = "all";
  filterName: string = null;
  empDetails: EmpDetails[] = [];
  nullver: number = 1;
  issearch: boolean = false;

  constructor(
    private router: Router,
    private identityProvisioningService: IdentityProvisioningService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    
    this.fetchempDetails();
    this.cdr.detectChanges(); 
  }

handleAction(event: { action: string, rowIndex: number, rowData: any }) {
  console.log(` Row Index: ${event.rowIndex}`, event.rowData);

  if (event.action === 'update') {
    this.transferEmp(event.rowIndex);
  } else if (event.action === 'delete') {
    if (!this.isDeleteAllowed(event.rowData)) {
      return; // disabled / not allowed
    }
    this.terminateEmployee(event.rowIndex);
  }
}

 buttonConfig = (row: EmpDetails) => ({
  update: true,
  delete: row?.status?.toLowerCase() === 'active'
});

  async fetchempDetails() {
    try {
      const response = await this.identityProvisioningService
        .getAssignedIdEmpDetails(this.currentPage - 1)
        .toPromise();
        this.filteredData = [...response];
  
      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesNormal = response[0].totalPages;
        this.totalPages = this.totalPagesNormal;  // Sync `totalPages` with `totalPagesNormal`
        this.currentPage = response[0].currentPage + 1;
      }
    
    } catch (error) {
      console.error("Error fetching assets :", error);
    }
  }


  columnStyles = {
    4: (value: any) => {
      if (value === 'active') {
        return 'activeCol';  // Style for active status
      }  else  {
        return 'deletedCol';  // Style for deleted status
      } 
    }
  };


  async fetchempDetailsSearch() {
    try {
      const response = await this.identityProvisioningService.getAssignedIdEmpDetailsSearch(this.currentPage - 1, this.searchText, this.filterByHeader).toPromise();
      this.searchedData = [...response];
  
      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearch = response[0].totalPages;
        this.totalPages = this.totalPagesSearch;  // Sync `totalPages` with `totalPagesSearch`
        this.currentPage = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  }

    async searchempDetails(): Promise<void> {
    try {
      if (this.searchText) {

        // Default value
        if (!this.filterByHeader) {
          this.filterByHeader = "all";
        }

        this.issearch = true;

        await this.fetchempDetailsSearch();
        this.totalPages = this.totalPagesSearch;

        const selectedHeader = this.headers.find(
          (h) => h.property === this.filterByHeader && h.showInDropdown
        );

        if (this.filterByHeader === "all") {

          this.searchedData = this.searchedData.filter((rule) =>
            this.headers.some((header) => {
              const value = rule[header.property];

              return value
                ?.toString()
                .toLowerCase()
                .includes(this.searchText.toLowerCase());
            })
          );

        } else if (selectedHeader) {

          this.searchedData = this.searchedData.filter((rule) => {
            const value = rule[selectedHeader.property];

            return value
              ?.toString()
              .toLowerCase()
              .includes(this.searchText.toLowerCase());
          });

          this.searchedData.sort((a, b) =>
            a[selectedHeader.property]
              ?.toString()
              .localeCompare(b[selectedHeader.property]?.toString())
          );

        } else {
          this.filteredData = [];
        }

      } else {

        this.issearch = false;
        await this.fetchempDetails();

      }
    } catch (error) {
      console.error("Error during search:", error);
    }
  }

  back() {
    try {
      if (this.issearch) {
        this.issearch = false;
        this.totalPages = this.totalPagesNormal;  // Restore total pages for normal pagination
        this.currentPage = 1;
        this.fetchempDetails(); 
      } else {
        this.router.navigate(['digital-identity/auth-tools']);
      }
     } catch (error) {
        console.error("Error fetching Assets:", error);
     }
  }


    async clearData(index: number) {
      try {
        const dialogRef = this.dialog.open(DeleteDialogComponent, {
          data: {
            title: "Are you sure?",
            message: "Do you really want to clear all data?",
            isConfirm: false,
          },
        });
  
        const result = await dialogRef.afterClosed().toPromise(); // Wait for user response
  
        if (result) {
           await this.identityProvisioningService.clearData().toPromise();
            this.fetchempDetails();

          this.dialog.open(DeleteDialogComponent, {
            data: {
              title: "Success",
              message: "All employees data has been deleted successfully.",
              isConfirm: true,
            },
          });
        }
  
      } catch (error) {
        console.error("Error deleting Asset Source:", error);
      }
    }
  

  async assign() {
    const response = await this.identityProvisioningService
      .AssignDigitalId(this.nullver)
      .toPromise();
  }

  async transferEmp(index: number) {
    if(this.issearch){
      this.router.navigate([
        "digital-identity/auth-tools/identity-admin-panel/transferemp",
        this.searchedData[index].guid,
        this.searchedData[index].organization,
        this.searchedData[index].organizational_unit,
        this.searchedData[index].organizationId,
      ]);
    }
    else{
      this.router.navigate([
        "digital-identity/auth-tools/identity-admin-panel/transferemp",
        this.filteredData[index].guid,
        this.filteredData[index].organization,
        this.filteredData[index].organizational_unit,
        this.filteredData[index].organizationId,
      ]);
    }
   
  }

  transferOrg() {
    this.router.navigate([
      "digital-identity/auth-tools/identity-admin-panel/transferorganizationunit",
    ]);
  }

  terminationReason: string=null;

  isDeleteAllowed(row: EmpDetails): boolean {
  return row?.status?.toLowerCase() === "active";
}

  async terminateEmployee(index: number) {
  try {
    const row = this.issearch
      ? this.searchedData[index]
      : this.filteredData[index];

    if (!this.isDeleteAllowed(row)) {
      return;
    }

    const digitalId = row.guid;

    const dialogRef = this.dialog.open(TerminateDialogComponent, {
      data: {
        title: "Change Asset Status",
        message: "The rule has been deleted successfully.",
        digitalId: digitalId,
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result?.success) {
      this.terminationReason = result.reason;
      this.openSuccessDialog();

      if (this.issearch) {
        this.fetchempDetailsSearch();
      } else {
        this.fetchempDetails();
      }
    } else {
      console.log("Termination was canceled.");
    }
  } catch (error) {
    console.error("Error terminating Employee:", error);
  }
}

   openSuccessDialog(): void {
      const dialogRef = this.dialog.open(SuccessDialogComponent, {
        width: "250px",
        data: {
          isMessage: true,
          isCreateUpdate: false,
          
          subTitle:`${this.terminationReason} is successfull.`,
        },
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        this.router.navigate([
          "digital-identity/auth-tools/identity-admin-panel",
        ]);
      });
    }
  


  //  async deleteRule(index: number) {
  //      try {
  //        // await this.ruleService.deleteRule(this.rules[index].ruleid).toPromise();
  //        // this.rules = await this.ruleService.getRules(this.nullver).toPromise();
   
  //              const dialogRef = this.dialog.open(DeleteDialogComponent, {
  //            data: {
  //              title: "Are you sure?",
  //              message: "Do you really want to delete this Rule?",
  //              isConfirm: false
  //            },
  //          });
   
  //          const result = await dialogRef.afterClosed().toPromise(); // Wait for user response
     
  //                   if (result) {
        
  //        if(this.issearch){
  //          await this.ruleService
  //          .deleteRule(this.searchedData[index].ruleId).toPromise();
  //          this.fetchRules();
  //        }
  //        else{
  //          await this.ruleService
  //          .deleteRule(this.filteredData[index].ruleId).toPromise();
  //          this.fetchRules();
  //        }
   
  //        this.dialog.open(DeleteDialogComponent, {
  //          data: {
  //              title: "Success",
  //              message: "The Rule has been deleted successfully.",
  //              isConfirm: true
  //           },
  //         });
  //      }
   
           
     
  //      } catch (error) {
  //        console.error("Error deleting Rule:", error);
  //      }
  //    }


}
